import CloseIcon from '@mui/icons-material/Close';
import { IconButton } from '@mui/material';
import { closeSnackbar, enqueueSnackbar } from 'notistack';
import { SahinAlertDialogProps } from './AlertDialog.types';

export const sahinAlertDialog = ({
  message,
  type,
  duration = 4000,
  isCloseButton = true,
  customActionButton,
  persist = false,
}: SahinAlertDialogProps) => {
  const action = (snackbarId: any) => (
    <>
      {customActionButton && <IconButton {...customActionButton} />}
      {isCloseButton && (
        <IconButton
          onClick={() => {
            closeSnackbar(snackbarId);
          }}
        >
          <CloseIcon />
        </IconButton>
      )}
    </>
  );

  enqueueSnackbar(message, {
    autoHideDuration: duration,
    action,
    variant: type,
    persist,
  });
};
